import { useTranslation } from 'react-i18next';
import type { CapabilityStatus } from '@shared/content-schemas';

/**
 * "In development" / "Planned — not yet available". The words carry the
 * meaning; the color and the icon only repeat it.
 */
export function StatusBadge({ status }: { status: CapabilityStatus }) {
  const { t } = useTranslation();
  const planned = status === 'planned';
  return (
    <span className={`badge ${planned ? 'badge-planned' : 'badge-development'}`}>
      <span aria-hidden="true" className="badge-icon">
        {planned ? '○' : '◐'}
      </span>
      {planned ? t('status.planned') : t('status.inDevelopment')}
    </span>
  );
}
